import { api, getAuthHeader } from "../axiosConfig"

export async function importService(cid, data) {
  return await api
    .post(`/data/import/${cid}`, data, { headers: getAuthHeader() })
    .then((res) => {
        return res.data;
    })
    .catch((err) => { return err.response });
}